// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zexs","newExpiryDate":"styles_newExpiryDate__3z9o8","footer":"styles_footer__1568t"};